/** Context that folds under a record: a summary line with a chevron and a count. */
import type { ReactNode } from "react";
import { ChevronRightIcon } from "./icons.js";
import { cx } from "./primitives.js";

export interface FoldProps {
  title: ReactNode;
  count?: ReactNode;
  defaultOpen?: boolean;
  /** `also` is the one-line "Also today" fold under Done. */
  className?: string;
  children: ReactNode;
}

export function Fold({ title, count, defaultOpen, className, children }: FoldProps) {
  return (
    <details className={cx("fold", className)} open={defaultOpen}>
      <summary>
        <ChevronRightIcon />
        {title}
        <span className="n">{count}</span>
      </summary>
      <div className="fb">{children}</div>
    </details>
  );
}
